export const getFormState = (donationType) => {
  const defaultKeys = {
    email: "",
    phone: "",
    firstname: "",
    lastname: "",
    address: "",
    zip: "",
    city: "",
    isMasked_firstname: false,
    isMasked_lastname: false,
    isMasked_address: false,
    isMasked_zip: false,
    isMasked_city: false,
    method: "",
    amount: "",
    socialsecuritynumber: "",
    donation_type: donationType,
  };

  if (donationType === "memorial") {
    return {
      ...defaultKeys,
      selected_card: "",
      card_text: "",
      delivery_method: "",
      delivery_recipient: "",
      burial_date: "",
      honoree_name: "",
    };
  } else if (donationType === "tribute") {
    return {
      ...defaultKeys,
      selected_card: "",
      card_text: "",
      delivery_method: "",
      delivery_recipient: "",
    };
  } else if (donationType === "company") {
    const { 
      socialsecuritynumber, 
      isMasked_firstname,
      isMasked_lastname,
      isMasked_address,
      isMasked_zip,
      isMasked_city,
      ...rest 
    } = defaultKeys;

    return {
      ...rest,
      companyname: "",
      orgnumber: "",
    };
  } else if (donationType === "monthly") {
    return {
      ...defaultKeys,
      bank: "",
      account: "",
      clearing: "",
      method: "autogiro",
      autogiro_optIn: false,
    };
  } else {
    return {
      ...defaultKeys,
    };
  }
};
